import { Space, Table, message, Popconfirm, Spin } from "antd";
import { EditOutlined, DeleteFilled } from "@ant-design/icons";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { del, get } from "../../../services";

const Usertable = () => {
  const [userData, setUserData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const navigate = useNavigate();
  // method for API call
  const getUserHandler = () => {
    setLoader(true);
    //axios call
    get(`/user/bankdetails/getAll`)
      .then((response) => {
        setUserData(response?.data);
        console.log(response);
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
      });
  };

  // confirm handler
  const confirm = (data) => {
    setSelectedRecord(data?._id);
    // API call to delete selected record
    del(`/user/bankdetails/${data?.employeeId?._id}`)
      .then(() => {
        // to delete locally from our frontend lists
        const remaingRecords = userData?.filter(
          (item) => item?._id !== data?._id
        );
        setUserData(remaingRecords);
        // success message
        message.success("Record deleted Successfully");
        setSelectedRecord(false);
      })
      .catch(() => {
        message.error("Error");
        setSelectedRecord(false);
      });
  };

  //  API for user
  useEffect(() => {
    getUserHandler();
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "_id",
      key: "_id",
      render: (_, __, index) => <Space>{index + 1}</Space>,
    },
    {
      title: "Name",
      dataIndex: "",
      key: "",
      render: (data) => (
        <div>
          <Space size="middle">{data?.employeeId?.name}</Space>
        </div>
      ),
    },
    {
      title: "Account Number",
      dataIndex: "",
      key: "",
      render: (data) => <Space size="middle">{data?.accountNumber}</Space>,
    },
    {
      title: "Bank Name",
      dataIndex: "",
      key: "",
      render: (data) => <Space size="middle">{data?.bankName}</Space>,
    },
    {
      title: "Branch Name",
      dataIndex: "",
      key: "",
      render: (data) => <Space size="middle">{data?.branchName}</Space>,
    },
    {
      title: "Code",
      dataIndex: "",
      key: "",
      render: (data) => <Space size="middle">{data?.ifscCode}</Space>,
    },
    {
      title: "Action",
      key: "action",
      render: (data, __, index) => (
        <Space>
          <div className="flex">
            <div className="px-4">
              <EditOutlined
                className="cursor-pointer"
                onClick={() => {
                  navigate(`/edit-bank-details/${data?.employeeId?._id}`);
                }}
              />
            </div>
            <div className="px-4">
              {data?._id === selectedRecord ? (
                <Spin />
              ) : (
                <Popconfirm
                  title="Delete the task"
                  description="Are you sure to delete this task?"
                  onConfirm={() => confirm(data, index)}
                  okText="Yes"
                  cancelText="No"
                >
                  <DeleteFilled className="cursor-pointer" />
                </Popconfirm>
              )}
            </div>
          </div>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div className="header" style={{ paddingBottom: "15px" }}>
        <h3>Bank Details</h3>
        <div className="events-button">
          <Link to="/add-bank-details">
            <button className="cursor-pointer add-event">
              Add Bank Details
            </button>
          </Link>
        </div>
      </div>
      {/* table */}
      <div>
        <Table
          columns={columns}
          dataSource={userData}
          loading={loader}
          pagination={false}
          scroll={{ x: 1023 }}
        />
      </div>
    </div>
  );
};
export default Usertable;
